import { Avatar } from "antd";
import { FC, useState } from "react";
import { useParams } from "react-router-dom";
import {
  emptyStarSVG,
  locationSVG,
  smallClockSVG,
} from "../../../assets/SVGs/SVGs";
import { formateTimeToAMPM } from "../../../utils/DateUtils";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

interface SalonProfileProps {
  salonDetails: any;
}

const SalonProfile: FC<SalonProfileProps> = ({ salonDetails }) => {
  const intl = useIntl();
  const { currentLang } = useSelector((state: any) => state?.user);
  const [imgUrl, setImgUrl] = useState(
    salonDetails?.settings?.find((item: any) => item?.key === "brand_logo")
      ?.media[0]?.media_url || ""
  );
  function getTodayWorkingHOurs() {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const today = new Date();
    const workingHours = salonDetails?.opening_hours?.find(
      (item: any) => item?.day === daysOfWeek[today.getDay()]
    );
    if (workingHours) {
      return {
        opening_time: workingHours?.opening_time?.slice(0, 5),
        closing_time: workingHours?.closing_time.slice(0, 5),
      };
    } else {
      return {
        opening_time: "00:00",
        closing_time: "00:00",
      };
    }
  }

  return (
    <div className="w-full  absolute top-[-140px] left-1/2 -translate-x-1/2 space-y-4flex flex-col justify-center items-center space-y-6">
      <div className="space-y-4   ">
        <div className="mb-4">
          <h2 className="text-3xl !text-salon-secondary text-center ">
            {salonDetails?.name}
          </h2>
        </div>
        <div className="flex justify-center">
          <Avatar
            src={imgUrl}
            className="bg-white text-black shadow"
            size={150}
          ></Avatar>
        </div>
      </div>
      <div className="  flex flex-col items-center justify-center gap-1">
        <div className="flex gap-1 text-color-sec-title ">
          <span className="translate-y-0.4">{locationSVG}</span>
          <span className=""> {salonDetails?.business_location?.Address}</span>
        </div>
        <div className="flex gap-6 text-color-sec-title">
          <p className="flex gap-1">
            <span className="translate-y-0.4">{emptyStarSVG}</span>
            <span>{Number(salonDetails?.reviews?.rate)?.toFixed(1)}</span>
            <span>{`(${salonDetails?.reviews?.reviewers})`}</span>
          </p>
          <p className="flex gap-1 items-center flex-wrap">
            <span className="translate-y-0.5">{smallClockSVG}</span>
            <span className="text-color-sec-title ">
              <span className="me-1">{intl.formatMessage({ id: "from" })}</span>
              {formateTimeToAMPM(
                getTodayWorkingHOurs().opening_time,
                currentLang
              )}
            </span>
            {/* <small className="text-color-sec-title text-xs self-end">
              صباحاً
            </small> */}
            <span>-</span>
            <span>
              {" "}
              <span className="me-1">{intl.formatMessage({ id: "to" })}</span>
              {formateTimeToAMPM(
                getTodayWorkingHOurs().closing_time,
                currentLang
              )}
            </span>
            {/* <small className="text-color-sec-title text-xs self-end">
              مساءاً
            </small> */}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SalonProfile;
